import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Alert,
    Button,
    Stack,
    Text,
    HStack,
    Flex
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {AlertIcon} from '@salesforce/retail-react-app/app/components/icons'
import ResetPasswordFields from '../../components/forms/reset-password-fields'
import ResetPasswordLanding from '../../pages/reset-password/reset-password-landing'
import {useHistory} from 'react-router-dom'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

const ResetPasswordForm = ({
    submitForm,
    form,
    isAccountDashboard = false,
    setShouldShowHeading = noop,
    clickSignIn
}) => {
    const history = useHistory()

    return (
        <Fragment>
            {!form.formState.isSubmitSuccessful ? (
                <form
                    onSubmit={form.handleSubmit(submitForm)}
                    data-testid="sf-auth-modal-form"
                    noValidate
                >
                    <Stack spacing={6} w={{base: '100%', lg: '458px'}}>
                        <Flex direction="column" gap="48px">
                            {isAccountDashboard && (
                                <Text as="h1" textStyle="webH1">
                                    <FormattedMessage
                                        defaultMessage="Change Password"
                                        id="reset_password_form.title.change_password"
                                    />
                                </Text>
                            )}

                            <Text textStyle="bodyXsSRegular" fontSize={'14px'} fontWeight={'400'}>
                                {isAccountDashboard ? (
                                    <FormattedMessage
                                        defaultMessage="Enter your email and we will send you more information to change your password."
                                        id="change_password_form.info.enter_your_email"
                                    />
                                ) : (
                                    <FormattedMessage
                                        defaultMessage="Enter your email and we will send you more information to reset your password."
                                        id="reset_password_form.info.enter_your_email"
                                    />
                                )}
                            </Text>
                        </Flex>

                        {form.formState.errors?.global && (
                            <Alert status="error">
                                <AlertIcon color="red.500" boxSize={4} />
                                <Text fontSize="sm" ml={3}>
                                    {form.formState.errors.global.message}
                                </Text>
                            </Alert>
                        )}

                        <ResetPasswordFields isAccountDashboard={isAccountDashboard} form={form} />

                        <Button
                            type="submit"
                            data-testid="send-email-button"
                            onClick={() => form.clearErrors('global')}
                            isLoading={form.formState.isSubmitting}
                            isDisabled={!form.watch('email')}
                            variant="webPrimary"
                            w={{base: 'full', lg: '225px'}}
                        >
                            <FormattedMessage
                                defaultMessage="Send email"
                                id="reset_password_form.button.send_email"
                            />
                        </Button>
                        {!isAccountDashboard && (
                            <HStack>
                                <Text textStyle="bodyXsSRegular">
                                    <FormattedMessage
                                        defaultMessage="Or return to"
                                        id="reset_password_form.message.return_to_sign_in"
                                        description="Precedes link to return to sign in"
                                    />
                                </Text>
                                <Button
                                    variant="link"
                                    data-testid="sign-in-button"
                                    size="sm"
                                    onClick={
                                        clickSignIn ? clickSignIn : () => history.push('/login')
                                    }
                                >
                                    <FormattedMessage
                                        defaultMessage="Sign in"
                                        id="reset_password_form.action.sign_in_page"
                                    />
                                </Button>
                            </HStack>
                        )}
                    </Stack>
                </form>
            ) : (
                <Stack justify="center" pt={0}>
                    <ResetPasswordLanding
                        isAccountDashboard={isAccountDashboard}
                        email={form.getValues('email')}
                        submitForm={submitForm}
                        clickSignIn={clickSignIn ? clickSignIn : () => history.push('/login')}
                        setShouldShowHeading={setShouldShowHeading}
                    />
                </Stack>
            )}
        </Fragment>
    )
}

ResetPasswordForm.propTypes = {
    submitForm: PropTypes.func,
    setShouldShowHeading: PropTypes.func,
    form: PropTypes.object,
    isAccountDashboard: PropTypes.bool,
    clickSignIn: PropTypes.func
}

export default ResetPasswordForm
